import { render, staticRenderFns } from "./ThankAfterRegistration.vue?vue&type=template&id=04765b82&"
import script from "./ThankAfterRegistration.vue?vue&type=script&lang=js&"
export * from "./ThankAfterRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports